import { useContainer } from "#imports";
import { DependencyInjectId } from "@@/package/const/DependencyInjectId";
import TrackMapper from "@@/package/mapper/track/TrackMapper";
import { TrackModel } from "@@/package/mapper/track/model/TrackModel";
import type TrackFilterResponse from "~~/package/apis/track/response/TrackFilterResponse";
import { PageModel } from "~~/package/mapper/common/model/PageModel";
import type TrackResponse from "~~/package/apis/track/response/TrackResponse";
import { SkillAdvanceType } from "~~/package/mapper/track/model/SkillAdvanceType";
import { TrackStatusType } from "~~/package/mapper/track/model/TrackStatusType";
import { SkillAdvanceMyTrackModel } from "~~/package/mapper/track/model/SkillAdvanceMyTrackModel";

export const useTrackService = () => {
    const trackMapper = useContainer<TrackMapper>(DependencyInjectId.TrackMapper);

    const getAdvanceList = (filter: string[], page: number, itemSize: number, advanceType: SkillAdvanceType, field?: string): Promise<PageModel<TrackModel>> => {
        return trackMapper.getAdvanceList(filter, page, itemSize, advanceType, field);
    };

    const getMyAdvanceList = (page: number, itemSize: number, lang: string, filter: string[], advanceType: SkillAdvanceType, field?: string, status?: TrackStatusType): Promise<PageModel<SkillAdvanceMyTrackModel>> => {
        return trackMapper.getMyAdvanceList(page, itemSize, lang, filter, advanceType, field, status);
    }

    const getTrack = (id: number, lang: string, advanceType = SkillAdvanceType.LEARN): Promise<TrackModel> => {
        return trackMapper.getTrack(id, lang, advanceType);
    }

    const startTrack = (id: number): Promise<Boolean> => {
        return trackMapper.startTrack(id);
    }

    const getTrackFilter = (includes?: string): Promise<TrackFilterResponse[]> => {
        return trackMapper.getTrackFilter(includes);
    }

    return {getAdvanceList,getMyAdvanceList, getTrack, startTrack, getTrackFilter};
}
